import React from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';
import ListPostbacksComponent from './ListPostbacks/ListPostbacks.container.js';
import { getPath } from '../../../utils/Router';
import { Link } from '../../RouterCompatibility';

const ListPostbackPage = ({ t }) => {
    const staticNames = t?.postbackPage?.list || {};

    return (
        <React.Fragment>
            <div className="page-heading page-heading__with-button">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>

                    <Link className="header-button add-button apply-btn btn" to={getPath('createPostback')}>
                        <span>{staticNames.create}</span>
                    </Link>
                </div>
            </div>

            <section className="wrapper-content tools">
                <div className="ibox postback">
                    <ListPostbacksComponent />
                </div>
            </section>
        </React.Fragment>
    );
};

ListPostbackPage.propTypes = {
    t: PropTypes.object
};

ListPostbackPage.defaultProps = {
    t: {}
};

export default withTranslation(ListPostbackPage);
